<div class="pagenotfound-page">
    <div style="text-align: center;">
        <img src="assets/smart_symbol_Logo_P_rgb.png" alt="Image"  height="150.55px">
    </div>
    <h1 style="color: red;text-align: center;" > Page not found ! </h1>

</div>

